// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1V42v","sound":"styles_sound__38JXY","videoPlayer":"styles_videoPlayer__1zsFe"};